import React from "react";
import { Link } from "react-router-dom";
import * as PR from "../../prime-modules/index";
import { PageNotFound } from "../../assets/images/index";

// CSS
import "./Notfound.scss";

const NotFound = () => {
  return (
    <>
      <section className="notfound-section">
        <div className="grid grid-nogutter align-items-center custom-height">
          <div className="col-12 text-center">
            <PR.Image src={PageNotFound} alt="not found" className="notfound-img" />
            <h1 className="text-4xl font-semibold"> Not found </h1>
            <Link to="/" className="backtohome-btn"><i className="pi pi-chevron-left"></i> Back to home</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default NotFound;